module.exports = __webpack_public_path__ + "static/media/b-bg.7271a39c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b-bg.svg
// module id = 456
// module chunks = 0